import { ReactElement } from 'react'
import styled from 'styled-components'
import { I18n } from 'common'
import { defaultTheme } from '../../../../../../src/theme'
import { VehicleInfoProps } from '../../../../../../src/features/SummaryPanel/Interfaces'
import { Price } from '../../../../../../src/ui-components'
import { SectionTitle, ReceiptTableGrid, ReceiptCell } from './printStyles'

interface Props {
  vehicles: VehicleInfoProps[]
  grandTotal: number
  showYourCost: boolean
  displayExclTax?: boolean
}

const Summary = (props: Props): ReactElement => {
  const { grandTotal, vehicles, showYourCost, displayExclTax } = props

  return (
    <Wrapper>
      <SectionTitle>
        <I18n name="orderSummary" />
      </SectionTitle>
      <ReceiptTableGrid $columns={showYourCost ? '2fr 1fr' : '1fr'}>
        <ReceiptCell $header $align="start">
          <I18n name="cart" />
        </ReceiptCell>
        {showYourCost && (
          <ReceiptCell $header $align="end">
            <I18n name="orderTotal" />
          </ReceiptCell>
        )}

        {vehicles.map((vehicle) => (
          <VehicleRow key={vehicle.vehicleName}>
            <ReceiptCell $align="start">{vehicle.vehicleName}</ReceiptCell>
            {showYourCost && (
              <ReceiptCell $align="end">
                <Price num={vehicle.vehicleSummary?.vehicleTotalCost ?? 0} />
              </ReceiptCell>
            )}
          </VehicleRow>
        ))}

        {showYourCost && (
          <GrandTotalRow>
            <GrandTotalLine>
              <I18n name="grandTotal" />
              <Price num={grandTotal} />
            </GrandTotalLine>
            {displayExclTax && (
              <ExclTaxText>
                <I18n name="displayExclTax" />
              </ExclTaxText>
            )}
          </GrandTotalRow>
        )}
      </ReceiptTableGrid>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 2px;
`

const VehicleRow = styled.div`
  display: contents;
`

const GrandTotalRow = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-weight: 700;
  color: ${defaultTheme.colors.white};
  background-color: ${defaultTheme.colors.black};
  padding: 4px 8px;
  font-size: 11pt;
  line-height: 14pt;
`

const GrandTotalLine = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

const ExclTaxText = styled.p`
  font-style: italic;
  font-size: 8pt;
  color: ${defaultTheme.colors.white};
  margin: 0;
  font-weight: 400;
`

export default Summary
